"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
var React = tslib_1.__importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var context_1 = require("@eduzz/houston-forms/deprecated/context");
var useForm_1 = require("@eduzz/houston-forms/deprecated/useForm");
var withForm = function (Component) {
    return React.forwardRef(function (_a, ref) {
        var name = _a.name, errorMessage = _a.errorMessage, disabled = _a.disabled, props = tslib_1.__rest(_a, ["name", "errorMessage", "disabled"]);
        var form = (0, react_hook_form_1.useFormContext)();
        var formDeprecated = (0, useForm_1.useFormContext)();
        if ((!form && !formDeprecated) || !name) {
            return (0, jsx_runtime_1.jsx)(Component, tslib_1.__assign({}, props, { name: name, errorMessage: errorMessage, disabled: disabled, ref: ref }));
        }
        if (formDeprecated) {
            return withFormDeprecated(Component)(tslib_1.__assign({ name: name, errorMessage: errorMessage, disabled: disabled }, props), ref);
        }
        return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: form.control, name: name, render: function (_a) {
                var _b;
                var field = _a.field, fieldState = _a.fieldState, formState = _a.formState;
                return ((0, jsx_runtime_1.jsx)(Component, tslib_1.__assign({}, props, field, { onBlur: function (value, e) {
                        var _a;
                        field.onBlur();
                        (_a = props === null || props === void 0 ? void 0 : props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, value, e);
                    }, disabled: disabled || (formState === null || formState === void 0 ? void 0 : formState.isSubmitting), errorMessage: errorMessage !== null && errorMessage !== void 0 ? errorMessage : (_b = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _b === void 0 ? void 0 : _b.message, ref: ref })));
            } }));
    });
};
var withFormDeprecated = function (Component) {
    return function (_a, ref) {
        var name = _a.name, valueProp = _a.value, errorMessageProp = _a.errorMessage, disabled = _a.disabled, props = tslib_1.__rest(_a, ["name", "value", "errorMessage", "disabled"]);
        var isSubmitting = (0, context_1.useFormIsSubmitting)();
        var value = (0, context_1.useFormValue)(name, valueProp);
        var errorMessage = (0, context_1.useFormError)(name, errorMessageProp);
        var setFormValue = (0, context_1.useFormSetValue)(name);
        var handleChange = React.useCallback(function (value) { return setFormValue && setFormValue(value); }, [setFormValue]);
        return ((0, jsx_runtime_1.jsx)(Component, tslib_1.__assign({}, props, { name: name, value: value, onChange: handleChange, disabled: disabled || isSubmitting, errorMessage: errorMessage, ref: ref })));
    };
};
exports.default = withForm;
